import * as types from "./actionTypes";
import * as eventApi from "../../api/eventApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadEventsSuccess(events) {
  return { type: types.LOAD_EVENTS_SUCCESS, events };
}

export function loadEventSuccess(event) {
  return { type: types.LOAD_EVENT_SUCCESS, event };
}

export function createEventSuccess(event) {
  return { type: types.CREATE_EVENT_SUCCESS, event };
}

export function updateEventSuccess(event) {
  return { type: types.UPDATE_EVENT_SUCCESS, event };
}

export function addSiblingsOptimistic(siblings) {
  return { type: types.ADD_SIBLINGS_OPTIMISTIC, siblings };
}

export function deleteEventOptimistic(event) {
  return { type: types.DELETE_EVENT_OPTIMISTIC, event };
}

export function loadEvents(date, city) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return eventApi
      .getEvents(date, city)
      .then(events => {
        dispatch(loadEventsSuccess(events));
        return events;
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadEvent(id) {
  console.log("action " + id);
  return function (dispatch) {
    dispatch(beginApiCall());
    return eventApi
      .getEvent(id)
      .then(event => {
        dispatch(loadEventSuccess(event));
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function saveEvent(accessToken, event) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return eventApi
      .saveEvent(accessToken, event)
      .then(savedEvent => {
        event.id
          ? dispatch(updateEventSuccess(savedEvent))
          : dispatch(createEventSuccess(savedEvent));
        return savedEvent.id;
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function addSiblings(accessToken, siblings) {
  return function (dispatch) {
    dispatch(addSiblingsOptimistic(siblings));
    return eventApi.addSiblings(accessToken, siblings);
  };
}

export function deleteEvent(accessToken, eventId) {
  return function (dispatch) {
    dispatch(deleteEventOptimistic(eventId));
    return eventApi.deleteEvent(accessToken, eventId);
  };
}
